import React, { Component } from 'react'
import { isToday } from '@hlj/hlj-utils'
import { Flex } from 'hljd'
import style from './style.module.less'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import cls from 'classnames'
import {
  getUpdateContentTextColor,
  getUpdateMonthTextColor,
  getUpdateDayTextColor
} from '@components/LocalMerchant/Decoration/util'

class Media extends Component {
  render() {
    let {
      item: { photo, type, video }
    } = this.props
    photo = photo || {}
    video = video || {}
    const isPhoto = type == 1

    return (
      <div className={style.media}>
        {isPhoto ? (
          <img className={style.photo} src={photo.image_path} />
        ) : (
          <div className={style.videoWrapper}>
            <video src={video.origin_path} />

            <img
              src="//qnm.hunliji.com/o_1cnbhtmk6iu515pf1drl1v991aqa9.png"
              className="center"
            />
          </div>
        )}
      </div>
    )
  }
}

@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const {
      decorationStore: { newThemeConfig, theme },
      content,
      created_at,
      inspirations
    } = this.props
    const d = moment(created_at)

    return (
      <Flex
        className={style.item}
        style={{ borderBottom: `1px solid ${newThemeConfig['splitLine']}` }}
      >
        <Flex className={style.date} d="v" vc>
          <div
            className={style.day}
            style={{ color: getUpdateDayTextColor(theme) }}
          >
            {isToday(created_at) ? '今天' : d.format('DD')}
          </div>
          <div
            className={style.month}
            style={{ color: getUpdateMonthTextColor(theme) }}
          >
            {d.format('MM月')}
          </div>
        </Flex>

        <div>
          <div
            className={style.content}
            style={{ color: getUpdateContentTextColor(theme) }}
          >
            {content}
          </div>

          <div className={cls(style.medias, 'clearfix')}>
            {(inspirations || []).map(item => {
              return <Media key={item.id} item={item.media || {}} />
            })}
          </div>
        </div>
      </Flex>
    )
  }
}
